import { render, staticRenderFns } from "./FadeSlide.vue?vue&type=template&id=65c1332f&functional=true&"
import script from "./FadeSlide.vue?vue&type=script&lang=js&"
export * from "./FadeSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports